import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import mechaPageStore from '@src/pages/main/components/mechaPage/store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
// import AgeAppropriateTips from '@src/components/age-appropriate-tips';
import toWebpImage from '@src/utils/to-webp-image';
const styles = require('./index.less');

const mechaPage = ({ store }) => {
  store.use();
  const handleClick = e => {
    const target = e.target;
    if (target.className === 'more') {
      const item = store.page4Data?.mechaList[target.getAttribute('data-btn')];
      store.toDetails(item.mecha_id);
    }
  };
  const versionSwiper = () => {
    if (store.page4Data?.mechaList?.length > 0) {
      return (
        <div className={(styles.versionSwiper, 'versionSwiper')} onClick={handleClick}>
          <BaseSwiper store={store.versionSwiper}>
            {store.page4Data?.mechaList?.map((item, index) => {
              return (
                <div className={cx(styles.versionItem, 'versionItem')} key={index}>
                  <div
                    className="mecha-bg"
                    style={{
                      backgroundImage: `url(${item.mecha_gray_bg && item.mecha_gray_bg})`
                    }}
                  />
                  {store.formChange === 1 ? (
                    <div
                      className={cx(styles.versionImgs, 'versionImgs', store.Animating && 'versionImgs')}
                      style={{
                        backgroundImage: `url(${item.mecha_image && item.mecha_image})`
                      }}
                    />
                  ) : (
                    <div
                      className={cx(styles.versionImgs, 'formImgs', store.Animating && 'formImgs')}
                      style={{
                        backgroundImage: `url(${item.mecha_other_state_image && item.mecha_other_state_image})`
                      }}
                    />
                  )}
                  {item.mecha_other_state_name !== '' && (
                    <div className="formBox">
                      <div
                        className={cx('form1', store.formChange === 1 && 'mecha')}
                        onClick={() => store.handformChange(1)}
                        ref={el => store.handleTextOverflow(el, 'form1')}
                      >
                        <div className="scroll-wrapper">
                          <div className="text-copy">{item.mecha_default_state_name}</div>
                        </div>
                      </div>
                      <div
                        className={cx('form2', store.formChange === 2 && 'mecha')}
                        onClick={() => store.handformChange(2)}
                        ref={el => store.handleTextOverflow(el, 'form2')}
                      >
                        <div className="scroll-wrapper">
                          <div className="text-copy">{item.mecha_other_state_name}</div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="more"
                    data-btn={index}
                    style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/more-btn.png'))})` }}
                  />
                  <div
                    className="hud"
                    style={{
                      backgroundImage: `url(${toWebpImage(require('./images/hud.png'))})`
                    }}
                  />
                  <div className="delBox">
                    <div className="mecha_number">{item.mecha_number}</div>
                    <div className="namebox">{item.mecha_name}</div>
                    <div className="info">{item.mecha_type}</div>
                    <div className="infoBox">
                      <div>{item.mecha_tag_1}</div>
                      <div
                        className="rectangle"
                        style={{
                          backgroundImage: `url(${toWebpImage(require('./images/rectangle.png'))})`
                        }}
                      />
                    </div>
                    <div className="mecha_tag_2">{item.mecha_tag_2}</div>
                  </div>
                  <div
                    className="name"
                    style={{
                      backgroundImage: `url(${item.mecha_id_image})`
                    }}
                  />
                </div>
              );
            })}
          </BaseSwiper>
          <Link className={styles.prevBtn} onClick={store.versionTabSwiper.goPrev} />
          <Link className={styles.nextBtn} onClick={store.versionTabSwiper.goNext} />
          <div className={styles.tabSwiper}>
            <BaseSwiper store={store.versionTabSwiper}>
              {store.page4Data?.mechaList?.map((item, index) => {
                return (
                  <div className={cx('tabItem')} key={index}>
                    <div
                      className={cx('tabImgs', 'tabImg1')}
                      style={{
                        backgroundImage: `url(${item.mecha_tab_icon_act})`
                      }}
                    />
                    <div
                      className={cx('tabImgs', 'tabImg2')}
                      style={{
                        backgroundImage: `url(${item.mecha_tab_icon})`
                      }}
                    />
                  </div>
                );
              })}
            </BaseSwiper>
          </div>
          <Link
            onClick={() => store.toList()}
            className="footer"
            style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/go-to-details.png'))})` }}
          >
            <div className="count">
              <span style={{ color: '#02eff8' }}>
                {(store.versionSwiper.activeIndex + 1).toString().length === 1
                  ? '0' + (store.versionSwiper.activeIndex + 1)
                  : store.versionSwiper.activeIndex + 1}
              </span>/{store.page4Data?.mechaList?.length}
            </div>
          </Link>
        </div>
      );
    }
  };

  return <div className={cx(styles.root, styles.page4, store.isActive && styles.rootAvtive)}>{versionSwiper()}</div>;
};

export default wrapStore(mechaPage, mechaPageStore);
